@if (!isClosed()) {
  <div class="root">
    <button
      class="close-button"
      aria-label="Close"
      procure-button
      variant="ghost"
      condensedIcon="close"
      (click)="close()"
    ></button>
    <div class="header">
      <procure-ai-badge />
      <b>{{ title() }} Summary</b>
    </div>
    <div
      class="content"
      [innerHTML]="summary()"
    ></div>
  </div>
}
